module.exports = __webpack_public_path__ + "static/media/event-detail.e853c899.png";